import Button from '@passkeys/ui/button';
import Icon from '@passkeys/ui/icon';
import Text from '@passkeys/ui/text';

import { createNavigateStateOptions, useNavigate } from '@/ui/utils/navigation';
import type { BuyPageLocationState } from '../../buy/types.js';

interface EmptyStateProps {
  isFiltering: boolean;
}

function EmptyState({ isFiltering }: EmptyStateProps) {
  const navigate = useNavigate();

  return (
    <div className="mt-8 flex flex-col items-center">
      <Text
        align="center"
        size={13}
        className="text-black/50 theme-dark:text-white/50"
      >
        No activity yet.
      </Text>
      {isFiltering ? (
        <Text
          align="center"
          size={13}
          className="text-black/50 theme-dark:text-white/50"
        >
          Try another filter.
        </Text>
      ) : (
        <Button
          className="mt-2 h-4 font-mono text-xs font-medium uppercase"
          onClick={() =>
            navigate(
              '/buy',
              createNavigateStateOptions<BuyPageLocationState>({
                referrer: 'history',
              }),
            )
          }
          variant="tertiary"
          suffix={<Icon name="arrow-right" size={12} />}
        >
          Buy Crypto
        </Button>
      )}
    </div>
  );
}

export default EmptyState;
